import React from 'react';
import BreadcrumbsInterface from 'interfaces/breadcrumbs.interface';
import BreadcrumbsDropdown from './components/breadcrumbs-dropdown';
import BreadcrumbsStructuralData from './components/breadcrumbs-structural-data';
import Icon from 'atomic/icon';
import classNames from 'classnames';

import './breadcrumbs.desktop.scss';

const BreadcrumbsDesktop: React.FC<{breadcrumbs: BreadcrumbsInterface[];}> = ({ breadcrumbs }) => {
    if (breadcrumbs.length === 0) {
        return null;
    }

    return (
        <>
            <nav className="breadcrumbs-desktop__content" data-section="breadcrumbs">
                <div className="breadcrumbs-desktop">
                    {
                        breadcrumbs.map(breadcrumb => (
                            <div
                                key={breadcrumb.id}
                                className={classNames({
                                    'breadcrumbs-desktop__item': true,
                                    'breadcrumbs-desktop__item--oh': !breadcrumb.items
                                })}
                            >
                                {
                                    breadcrumb.url
                                        ? (
                                            <a
                                                href={breadcrumb.url}
                                                aria-label={breadcrumb.name}
                                                className="breadcrumbs-desktop__item__link"
                                            >
                                                {breadcrumb.prefix && (
                                                    <span>
                                                        {breadcrumb.prefix}
                                                        {': '}
                                                    </span>
                                                )}
                                                {breadcrumb.icon
                                                    ? (
                                                        <Icon name={breadcrumb.icon} color="dark" size={16} />
                                                    )
                                                    : (
                                                        breadcrumb.name
                                                    )}
                                                {breadcrumb.items && (
                                                    <Icon className="link-chevron" name="chevron-down" color="gray"
                                                        size={16}
                                                    />
                                                )}
                                            </a>
                                        )
                                        : (
                                            <>
                                                {breadcrumb.prefix && (
                                                    <span>
                                                        {breadcrumb.prefix}
                                                        {': '}
                                                    </span>
                                                )}
                                                <span className="breadcrumbs-desktop__item__name">
                                                    {breadcrumb.name}
                                                </span>
                                            </>
                                        )
                                }

                                {
                                    breadcrumb.items && <BreadcrumbsDropdown items={breadcrumb.items} />
                                }

                            </div>
                        ))
                    }
                </div>
            </nav>
            <BreadcrumbsStructuralData breadcrumbs={breadcrumbs} />
        </>
    );
};

export default BreadcrumbsDesktop;
